import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PanelMenuComponent } from './panel-menu/panel-menu.component';
import { WhiteboardComponent } from './whiteboard/whiteboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SliderModule } from 'primeng/slider';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    PanelMenuComponent,
    WhiteboardComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SliderModule,
    NgbCollapseModule
  ],
  exports: [
    PanelMenuComponent,
    WhiteboardComponent,
  ]
})
export class SharedModule { }
